import getSearchModalCurrentState from "./getSearchModalCurrentState";
import propagateSearchModalClose from "./propagateSearchModalClose";
import propagateSearchModalOpen from "./propagateSearchModalOpen";

export default function propagateSearchModalToggle() {
  // Check if we are in the client
  if (typeof window !== "object" || typeof CustomEvent !== "function") {
    console.warn(
      "[Search-ui] Calling search modal toggle on a server function, ignoring request...",
    );
    return;
  }

  const currentState = getSearchModalCurrentState();
  if (currentState) {
    propagateSearchModalClose();
  } else {
    propagateSearchModalOpen();
  }
}
